import React, { forwardRef } from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    error?: string;
    helperText?: string;
    leftIcon?: React.ReactNode;
    rightIcon?: React.ReactNode;
    containerClassName?: string;
}

const Input = forwardRef<HTMLInputElement, InputProps>(({
    label,
    error,
    helperText,
    leftIcon,
    rightIcon,
    className = '',
    containerClassName = '',
    id,
    ...props
}, ref) => {
    const inputId = id || props.name || Math.random().toString(36).substr(2, 9);

    return (
        <div className={`mb-3 ${containerClassName}`}>
            {label && (
                <label htmlFor={inputId} className="form-label">
                    {label}
                </label>
            )}

            <div className="position-relative">
                {leftIcon && (
                    <div className="position-absolute top-50 start-0 translate-middle-y ps-3 text-muted">
                        {leftIcon}
                    </div>
                )}

                <input
                    ref={ref}
                    id={inputId}
                    className={`form-control ${error ? 'is-invalid' : ''} ${leftIcon ? 'ps-5' : ''} ${rightIcon ? 'pe-5' : ''} ${className}`}
                    {...props}
                />

                {rightIcon && (
                    <div className="position-absolute top-50 end-0 translate-middle-y pe-3 text-muted">
                        {rightIcon}
                    </div>
                )}
            </div>

            {error && <div className="invalid-feedback d-block">{error}</div>}
            {!error && helperText && <div className="form-text">{helperText}</div>}
        </div>
    );
});

Input.displayName = 'Input';

export default Input;
